export default "https://cdn-static.gokick.com/assets/7e5886a8604a8a782ca6a0de4eecb197b7d69c39/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";